import React, { Fragment, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { getTrendingBooks } from '../../Services/BooksServices';
import Loader from '../Main/Loader';
import ProductCard from '../Main/ProductCard';


import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const TrendingThings = () => {

    const [booksData, setBooksData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const handleGetBooks = async () => {
        setIsLoading(true)
        let response = await getTrendingBooks()
        if (response.statusCode === 200) {
            setBooksData(response?.response?.data)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            toast?.error(response?.errors)

            setIsLoading(false)
        }
        setIsLoading(false)
    }


    useEffect(() => {
        handleGetBooks();
    }, [])


    return (
        <Fragment>



            <div className="container py-100">

                <div className="row justify-content-center pb-5">
                    <div className="col-lg-5">

                        <h2 className='heading text-center'>
                            Trending this week
                        </h2>

                        <p className='text-center para'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
                        </p>
                    </div>
                </div>
                <div className="row  justify-content-center">

                    <Swiper
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        spaceBetween={0}
                        slidesPerView={5}
                        navigation
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                            },
                            480: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 5,
                            },
                            1024: {
                                slidesPerView: 5,
                            },
                            1200: {
                                slidesPerView: 6,
                            },
                        }}
                    >
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                {Array.isArray(booksData) && booksData.length > 0 ? (
                                    booksData.map((item, i) => (
                                        <div className='col-lg'>

                                            <SwiperSlide className='container m-lg-0' key={i}>
                                                <ProductCard key={i} data={item} />
                                            </SwiperSlide>
                                        </div>
                                    ))
                                ) : (
                                    <p style={{ textAlign: "center", width: "100%" }}>No data found</p>
                                )}
                            </>
                        )}
                    </Swiper>



                </div>
            </div>
        </Fragment >
    )
}

export default TrendingThings